// workLogReducer.js
import { workLogConstants as C } from "../actions/constants";

const initialState = {
    items: [],
    loading: false,
    creating: false,
    error: null,

    totalMinutes: 0,
    totalAmount: 0,

    running: null,
    widgetOpen: true,
};

const replaceItem = (items, doc) => items.map((x) => (x._id === doc._id ? doc : x));

export const workLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case C.LIST_REQUEST:
            return { ...state, loading: true, error: null };
        case C.LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.payload.items,
                totalMinutes: action.payload.totalMinutes,
                totalAmount: action.payload.totalAmount,
            };
        case C.LIST_FAILURE:
            return { ...state, loading: false, error: action.error };

        case C.START_REQUEST:
            return { ...state, creating: true, error: null };
        case C.START_SUCCESS:
            return {
                ...state,
                creating: false,
                running: action.payload,
                items: [action.payload, ...state.items],
            };
        case C.START_FAILURE:
            return { ...state, creating: false, error: action.error };

        case C.STOP_REQUEST:
            return { ...state, creating: true, error: null };
        case C.STOP_SUCCESS:
            return {
                ...state,
                creating: false,
                running: null,
                items: replaceItem(state.items, action.payload),
                totalMinutes: state.totalMinutes + (action.payload.minutes || 0),
                totalAmount: state.totalAmount + (action.payload.amount || 0),
            };
        case C.STOP_FAILURE:
            return { ...state, creating: false, error: action.error };

        case C.UPDATE_SUCCESS:
        case C.PAY_SUCCESS:
            return { ...state, items: replaceItem(state.items, action.payload) };

        case C.SET_WIDGET_OPEN:
            return { ...state, widgetOpen: action.payload };

        default:
            return state;
    }
};
